import { useContext } from "react";
import { SceneContext } from "./scene-context";
import { SceneModel } from "./scene.model";

export function useScene<T extends { [key: string]: any } = {}>() {
  return useContext(SceneContext) as SceneModel<T>;
}
